<template>

    <div id="designer">
      <TheNavbarHorizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :showBookmarks="showBookmarks"
        :showSearch="showSearch"
        :showLanguageSelector="showLanguageSelector"
        :showNotificationDropDown="showNotificationDropDown"
        :resetNavHeight="resetNavHeight"
        />

      <Grid ref="grid" :clikID="clik_id" :exec_id="exec_id" @toggleModulesSidebar="toggleModulesSidebar" />

      <SettingsSidebar v-if="exec_id.length <= 0" @updateSettingsSideBarState="updateSettingsSideBarState" @toggleSettingsSidebar="toggleSettingsSidebar()" :active="settingsSideBarActive" :clikName="clikName" :clikDescription="clikDescription" @updateClikName="updateClikName" @updateClikDescription="updateClikDescription"/>

      <ModulesSidebar v-if="exec_id.length <= 0" @updateSideBarState="updateSideBarState" @toggleModulesSidebar="toggleModulesSidebar()" :active="sideBarActive" :moduleAdditionMethod="moduleAdditionMethod" :moduleTypeSought="moduleTypeSought" />

      <Buttons  v-if="exec_id.length <= 0" @toggleSettingsSideBar="settingsSideBarActive = !settingsSideBarActive" @run="run" @save="save" @delete="deleteClik" />

    </div>
</template>

<script>
import themeConfig         from '@/../themeConfig.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import Grid from './Grid.vue'
import ModulesSidebar from './ModulesSidebar.vue'
import SettingsSidebar from './SettingsSidebar.vue'

import Buttons from './Buttons.vue'

export default {
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      showScrollToTop   : themeConfig.showScrollToTop,
      isNavbarDark      : false,
      navbarColor       : '#10163a',
      navbarType        : themeConfig.navbarType  || 'floating',
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      showSearch: false,
      clikName: null,
      clikDescription: null,
      showBookmarks: false,
      showLanguageSelector: false,
      showNotificationDropDown: false,
      resetNavHeight: true,
      settingsSideBarActive: false,
      sideBarActive: false,
      moduleAdditionMethod: null,
      moduleTypeSought: null
    }
  },
  props: {
    clik_id: { type: String, required: true },
    id: { type: String, required: true },
    exec_id: { type: String, required: false, default: '' }
  },
  components: {
    TheNavbarHorizontal,
    Grid,
    ModulesSidebar,
    SettingsSidebar,
    Buttons
  },
  created () {
    const $this = this
    if (this.clik_id !== 'new') {
      //do ajax to get clik data and plumb in into grid
      //check if status is running - if get the latest data from websocket
 
      $this.$vs.loading()

      let destUrl = `${process.env.VUE_APP_API_ENDPOINT}/clik/${this.clik_id}`

      if (this.exec_id.length >= 1) {
        destUrl = `${process.env.VUE_APP_API_ENDPOINT}/clik/${this.clik_id}/queue/${this.exec_id}`
      }
      
      this.$http
        .get(destUrl, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        }).then(response => {
          let data = {}
          if (this.exec_id.length >= 1) {
            data = response.data.execution.snapshot
          } else {
            data = response.data.data
          }

          if (!(Object.keys(data).length === 0 && data.constructor === Object) && response.data.data !== null) {
            this.$refs.grid.modules = []
            this.$refs.grid.modules.push(data)
          }
          this.clikName = response.data.name
          this.clikDescription = response.data.description
          this.$refs.grid.createFlow()
          $this.$vs.loading.close()
        }).catch(() => {
          $this.$vs.loading.close()
          $this.$vs.notify({
            color: 'danger',
            title: 'Error loading Clik!'
          })
        })
    }
  },
  computed: {
    isThemeDark () {
      return true
    }
  },
  methods: {
    run () {
      this.save()

      //kick off the run via ajax POST
      //will get need to hook to websocket connection for feed update
    },
    save () {

      const $this = this

      //validation checks
      if (this.clikName === null || this.clikName.length <= 0) {
        return $this.$vs.notify({
          color: 'danger',
          title: 'You must set a name for the Clik'
        })
      }
      if (this.clikDescription === null || this.clikDescription.length <= 0) {
        return $this.$vs.notify({
          color: 'danger',
          title: 'You must set a description for the Clik'
        })
      }

      //create payload
      const payload_data = {
        name: this.clikName,
        description: this.clikDescription,
        data: this.$refs.grid.modules[0]
      }

      if (this.clik_id === 'new') {
        //add a new clik

        this.$http
          .post(`${process.env.VUE_APP_API_ENDPOINT}/project/${$this.id}/clik`, payload_data, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(response => {
            $this.$vs.notify({
              color: 'success',
              title: 'Clik Saved!'
            })
            $this.$router.replace(`/project/${$this.id}/clik/${response.data.guid}`)
          }).catch(error => {
            $this.$vs.notify({
              color: 'danger',
              title: error.response.data.message
            })
          })
      } else {
        //update an existing clik
        this.$http
          .put(`${process.env.VUE_APP_API_ENDPOINT}/clik/${$this.clik_id}`, payload_data, {
            headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
          }).then(() => {
            $this.$vs.notify({
              color: 'success',
              title: 'Clik Saved!'
            })
          }).catch(error => {
            $this.$vs.notify({
              color: 'danger',
              title: error.response.data.message
            })
          })
      }

    },
    deleteClik () {
      console.log('delete')
      const $this = this
      this.$http
        .delete(`${process.env.VUE_APP_API_ENDPOINT}/clik/${$this.clik_id}`, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        }).then(() => {
          $this.$router.replace(`/project/${$this.id}`)
        }).catch(error => {
          $this.$vs.notify({
            color: 'danger',
            title: error.response.data.message
          })
        })

    },
    updateSideBarState (a) {
      this.sideBarActive = a
    },
    updateSettingsSideBarState (a) {
      this.settingsSideBarActive = a
    },
    toggleModulesSidebar (a, b) {
      this.moduleType = a
      this.moduleAdditionMethod = b
      this.sideBarActive = true
    },
    toggleSettingsSidebar () {
      const $this = this
      $this.settingsSideBarActive = !$this.settingsSideBarActive
    },
    updateClikName (a) {
      this.clikName = a
    },
    updateClikDescription (a) {
      this.clikDescription = a
    }
  }

}
</script>
